"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_883 = void 0;
var Plan_883 = exports.Plan_883 = {
  planNumber: 883,
  kindOfCover: "ASIA Accident & GVE",
  externalName: "Essential Accident and Illness Cover",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,000",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 75,
    "excessCode": "3818",
    "excessNo": 3818
  }],
  levelsOfCover: [75],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 12000,
      "formattedAmount": "$12,000",
      "displayValue": "$12,000"
    },
    "paralysisTick": "$1,000 sub-limit",
    "tickParalysis": "$1,000 sub-limit",
    "consultationLimit": "$300 sub-limit",
    "consultationsAndVet": "$300 sub-limit",
    "consultationsAndVisits": "$300 sub-limit",
    "consultation": true,
    "cruciateLigament": "$2,600 sub-limit",
    "emergencyBoardingFees": "$1,000",
    "emergencyBoardingLimit": "$1,000 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "afterLifeCare": false,
    "alprazolam": false,
    "amitriptyline": false,
    "behaviouralAssessment": false,
    "behaviouralTherapy": false,
    "councilRegistration": false,
    "desexing": false,
    "essentialEuthanasia": false,
    "fleaControlDrugs": false,
    "fleaTickControlDrugs": false,
    "fleaWormDrugs": false,
    "groomingComplication": true,
    "heartWormDrugs": false,
    "intestinalWormDrugs": false,
    "jointSupplements": false,
    "microchipping": false,
    "oralRinseDrugs": false,
    "prescriptionDiet": false,
    "routineTeethCleaning": false,
    "teethCleaningProducts": false,
    "trazodone": false,
    "vaccinationCat": false,
    "vaccinationDog": false,
    "coversIllness": true,
    "infectiousDisease": true,
    "ingestionOfForeignBodies": true
  },
  isBasePlan: true,
  addOns: []
};
var _default = exports["default"] = {
  Plan_883: Plan_883
};